import { FC } from 'react';
import { Skeleton as MuiSkeleton } from '@mui/material';
import type { SkeletonProps } from '@mui/material';
import { SkeletonGradientDirection } from '@monorepo/nova-ui';
import { buildGradient } from './skeleton.utils';

interface ExtendedSkeletonProps extends SkeletonProps {
  gradientColors?: string[];
  gradientDirection?: SkeletonGradientDirection;
}

export const Skeleton: FC<ExtendedSkeletonProps> = ({
  gradientColors,
  gradientDirection = SkeletonGradientDirection.ToRight,
  ...rest
}) => {
  const gradientStyle = gradientColors
    ? { background: buildGradient(gradientColors, gradientDirection) }
    : {};

  return <MuiSkeleton {...rest} style={{ ...gradientStyle }} />;
};
